"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalsServiceDefinition = void 0;
const index_js_1 = require("../../index.js");
exports.SignalsServiceDefinition = (0, index_js_1.defineService)('core:signals');
